export const getFormattedPhoneNumber = phoneNumber => {
  const digits = phoneNumber.replace(/\D/g, '');

  if (digits.length === 0) return '';

  const national = digits?.slice(-10);
  const part1 = national?.slice(0, 3);
  const part2 = national?.slice(3, 6);
  const part3 = national?.slice(6);
  return `+1 ${part1} ${part2} ${part3}`;
};

const getFormattedPhoneNumberForBackEnd = phoneNumber =>
  phoneNumber.replace('+1 ', '').replace(/\s/g, '');

export const getPhoneNumbersToChange = (
  prevPhoneNumbers,
  currentPhoneNumbers,
) => {
  const phoneNumbersToAdd = currentPhoneNumbers
    .filter(({ value }) =>
      prevPhoneNumbers.every(
        ({ PhoneNumber }) =>
          PhoneNumber !== getFormattedPhoneNumberForBackEnd(value),
      ),
    )
    .map(({ value, isBestPhoneNumber }) => ({
      phoneNumber: getFormattedPhoneNumberForBackEnd(value),
      isBestPhoneNumber,
    }));
  const phoneNumbersToDelete = prevPhoneNumbers
    .filter(({ PhoneNumber }) =>
      currentPhoneNumbers.every(
        ({ value }) => getFormattedPhoneNumberForBackEnd(value) !== PhoneNumber,
      ),
    )
    .map(({ ContactPhoneNumberId }) => ContactPhoneNumberId);
  const hasPhoneNumbersToAdd = phoneNumbersToAdd.length > 0;
  const hasPhoneNumbersToDelete = phoneNumbersToDelete.length > 0;

  return {
    phoneNumbersToAdd,
    phoneNumbersToDelete,
    hasPhoneNumbersToAdd,
    hasPhoneNumbersToDelete,
  };
};
